(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ar-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.AiresExperience) return;
  const root = document.documentElement;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const narrow = window.matchMedia('(max-width: 699px)');
  const connection = navigator.connection;
  let paused = false, frame = 0, scenes = [], videos = [], revealObserver, videoObserver, headerObserver;
  try { paused = localStorage.getItem('aires-motion-paused') === 'true'; } catch {}
  const lowData = () => connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '');
  const enabled = () => document.body?.dataset.arMotion !== 'false' && !paused && !reduced.matches && !lowData();
  const sectionMotion = element => element.closest('[data-ar-section-motion]')?.dataset.arSectionMotion !== 'false';
  const sectionReveal = element => element.closest('[data-ar-section-reveal]')?.dataset.arSectionReveal !== 'false';
  const clamp = n => Math.max(0, Math.min(1, n));
  const draw = () => {
    frame = 0;
    if (!enabled()) return;
    const h = window.innerHeight, header = parseFloat(root.style.getPropertyValue('--ar-header')) || 80;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(video => {
        const rect = video.getBoundingClientRect();
        const visible = String(rect.bottom > 0 && rect.top < h);
        if (video.dataset.visible !== visible) { video.dataset.visible = visible; controlVideo(video); }
      });
    }
    scenes.forEach(scene => {
      const rect = scene.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > h) return;
      const progress = scene.classList.contains('ar-hero') ? (header - rect.top) / Math.max(1, rect.height - h + header) : (h - rect.top) / (h + rect.height);
      scene.style.setProperty('--ar-progress', clamp(progress).toFixed(4));
    });
  };
  const schedule = () => { if (!frame && !document.hidden) frame = requestAnimationFrame(draw); };
  const controlVideo = video => {
    if (!enabled() || !sectionMotion(video) || root.classList.contains('ar-intro-active') || document.hidden || video.dataset.visible !== 'true') { video.pause(); return; }
    const source = narrow.matches ? video.dataset.mobile : video.dataset.desktop;
    if (!source) return;
    if (video.dataset.loadedSource !== source) {
      video.classList.remove('is-ready');
      video.src = source;
      video.dataset.loadedSource = source;
      video.load();
    }
    video.muted = true;
    const pending = video.play();
    pending?.then(() => {
      if (!enabled() || !sectionMotion(video) || root.classList.contains('ar-intro-active') || document.hidden || video.dataset.visible !== 'true') video.pause();
    }).catch(() => { video.classList.remove('is-ready'); });
  };
  const sync = () => {
    const on = enabled();
    root.classList.toggle('ar-motion-on', on);
    root.classList.toggle('ar-motion-paused', !on);
    document.querySelectorAll('[data-ar-pause]').forEach(button => {
      button.hidden = reduced.matches || lowData() || document.body.dataset.arMotion === 'false';
      button.textContent = paused ? button.dataset.play : button.dataset.pause;
    });
    if (!on) {
      scenes.forEach(scene => scene.style.removeProperty('--ar-progress'));
      document.querySelectorAll('[data-ar-reveal]').forEach(el => el.classList.add('ar-in-view'));
    }
    videos.forEach(controlVideo);
    schedule();
    document.dispatchEvent(new CustomEvent('aires:motionchange'));
  };
  const measure = () => {
    const header = document.querySelector('.shopify-section-group-header-group:has(site-header)') || document.querySelector('site-header');
    const height = Math.round(header?.getBoundingClientRect().height || 0);
    root.style.setProperty('--ar-header', `${height}px`);
    root.style.setProperty('--ar-header-height', `${height}px`);
    schedule();
  };
  const refresh = () => {
    revealObserver?.disconnect(); videoObserver?.disconnect(); headerObserver?.disconnect();
    videos.forEach(video => { if (!video.isConnected) video.pause(); });
    scenes = [...document.querySelectorAll('[data-ar-scene]')].filter(sectionMotion);
    videos = [...document.querySelectorAll('[data-ar-video]')];
    if ('IntersectionObserver' in window) {
      videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
        entry.target.dataset.visible = String(entry.isIntersecting);
        controlVideo(entry.target);
      }), {rootMargin: '80px 0px', threshold: .01});
      videos.forEach(video => videoObserver.observe(video));
      if (enabled() && !window.Shopify?.designMode) {
        revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('ar-in-view'); revealObserver.unobserve(entry.target); }
        }), {threshold: .06, rootMargin: '0px 0px -20px 0px'});
        document.querySelectorAll('[data-ar-reveal]').forEach(el => {
          if (!sectionReveal(el) || el.getBoundingClientRect().top < window.innerHeight * .95) el.classList.add('ar-in-view');
          else { el.classList.add('ar-will-reveal'); revealObserver.observe(el); }
        });
      } else document.querySelectorAll('[data-ar-reveal]').forEach(el => el.classList.add('ar-in-view'));
    } else {
      videos.forEach(video => {
        const rect = video.getBoundingClientRect();
        video.dataset.visible = String(rect.bottom > 0 && rect.top < window.innerHeight);
      });
      document.querySelectorAll('[data-ar-reveal]').forEach(el => el.classList.add('ar-in-view'));
    }
    videos.forEach(video => {
      if (video.dataset.arBound) return;
      video.dataset.arBound = 'true';
      video.addEventListener('playing', () => video.classList.add('is-ready'));
      video.addEventListener('error', () => video.classList.remove('is-ready'));
    });
    const header = document.querySelector('site-header');
    if (header && 'ResizeObserver' in window) { headerObserver = new ResizeObserver(measure); headerObserver.observe(header); }
    measure(); sync();
  };
  document.addEventListener('click', event => {
    if (event.target.closest('[data-ar-pause]')) {
      paused = !paused;
      try { localStorage.setItem('aires-motion-paused', String(paused)); } catch {}
      sync();
    }
    const discover = event.target.closest('[data-ar-discover]');
    if (discover) {
      const href = discover.getAttribute('href') || '';
      const target = discover.hasAttribute('data-ar-first-lineup') || href === '#ar-lineup' ? document.querySelector('[data-ar-lineup]') : href.startsWith('#') ? document.getElementById(href.slice(1)) : null;
      if (target) {
        event.preventDefault();
        target.scrollIntoView({behavior: enabled() ? 'smooth' : 'auto', block: 'start'});
        const heading = target.querySelector('h2');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({preventScroll: true}); }
      }
    }
  });
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(refresh));
  document.addEventListener('visibilitychange', sync);
  document.addEventListener('aires:introchange', () => videos.forEach(controlVideo));
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', measure, {passive: true});
  window.addEventListener('pagehide', () => videos.forEach(video => video.pause()));
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  reduced.addEventListener?.('change', sync);
  narrow.addEventListener?.('change', () => videos.forEach(controlVideo));
  connection?.addEventListener?.('change', sync);
  window.AiresExperience = {refresh, enabled};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, {once: true}); else refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ar-intro"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.AiresIntro) return;
  const initialise = () => {
    const dialog = document.querySelector('[data-ar-intro]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    const root = document.documentElement;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const seenKey = 'aires-intro-seen-v1';
    let timer = 0, frame = 0, active = false, returnFocus = null;
    const allowed = () => {
      let paused = false;
      try { paused = localStorage.getItem('aires-motion-paused') === 'true'; } catch {}
      return !(dialog.dataset.mobileEnabled === 'false' && window.innerWidth < 700) && !reduced.matches && !paused && document.body.dataset.arMotion !== 'false' && window.AiresExperience?.enabled?.() !== false && !connection?.saveData && !/(^|-)2g$/.test(connection?.effectiveType || '');
    };
    const remember = () => { try { sessionStorage.setItem(seenKey, '1'); return true; } catch { return false; } };
    const finish = (restore = true) => {
      window.clearTimeout(timer);
      window.cancelAnimationFrame(frame);
      timer = frame = 0;
      active = false;
      dialog.classList.remove('is-playing');
      const wasOpen = root.classList.contains('ar-intro-active');
      root.classList.remove('ar-intro-active');
      if (wasOpen) document.dispatchEvent(new CustomEvent('aires:introchange'));
      if (dialog.open) dialog.close();
      if (restore && returnFocus?.isConnected) returnFocus.focus({preventScroll: true});
      returnFocus = null;
    };
    const start = (trigger = null) => {
      if (active || !allowed() || document.hidden) return;
      if (getComputedStyle(dialog).getPropertyValue('--ar-intro-ready').trim() !== '1') return;
      if (!trigger && !remember()) return;
      returnFocus = trigger || document.querySelector('[data-ar-hero-title]');
      if (returnFocus && !returnFocus.matches('button, a[href], input, [tabindex]')) returnFocus.setAttribute('tabindex', '-1');
      try {
        dialog.showModal();
        active = true;
        root.classList.add('ar-intro-active');
        document.dispatchEvent(new CustomEvent('aires:introchange'));
        remember();
        dialog.querySelector('[data-ar-intro-skip]')?.focus({preventScroll: true});
        const duration = parseFloat(getComputedStyle(dialog).getPropertyValue('--ar-intro-time')) || 3300;
        timer = window.setTimeout(() => finish(), duration + 200);
        frame = window.requestAnimationFrame(() => {
          frame = 0;
          if (active) dialog.classList.add('is-playing');
        });
      } catch { finish(); }
    };
    const sync = () => {
      const playable = allowed();
      if (!playable) finish();
      document.querySelectorAll('[data-ar-replay]').forEach(button => { button.hidden = !playable; });
    };
    dialog.querySelector('[data-ar-intro-skip]')?.addEventListener('click', () => finish());
    dialog.addEventListener('cancel', event => { event.preventDefault(); finish(); });
    dialog.addEventListener('close', () => { if (active) finish(); });
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-ar-replay]');
      if (trigger) { event.preventDefault(); start(trigger); }
    });
    document.addEventListener('aires:motionchange', sync);
    document.addEventListener('shopify:section:load', sync);
    document.addEventListener('shopify:section:unload', () => finish(false));
    document.addEventListener('visibilitychange', () => { if (document.hidden) finish(false); });
    window.addEventListener('pagehide', () => finish(false));
    window.addEventListener('pageshow', event => { if (event.persisted) finish(false); });
    reduced.addEventListener?.('change', sync);
    window.addEventListener('resize', sync, {passive: true});
    connection?.addEventListener?.('change', sync);
    window.AiresIntro = {play: start, close: finish};
    sync();
    if (dialog.dataset.editor === 'true' || window.Shopify?.designMode || !allowed() || window.scrollY > 60 || window.location.hash || document.hidden) return;
    let seen = true;
    try { seen = sessionStorage.getItem(seenKey) === '1'; } catch { return; }
    if (seen && dialog.dataset.frequency !== 'always') return;
    if (document.activeElement !== document.body && document.activeElement !== document.documentElement) return;
    start();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, {once: true});
  else initialise();
})();
  } catch(e) { console.error(e); }
})();

})();
